import React, { useContext, useEffect, useRef, useState } from "react";
import { Link } from "gatsby";
import { StaticImage } from 'gatsby-plugin-image';

import * as styles from "../styles/module/footer.module.scss";
import { ModalContext } from "./Layout";

const Footer = () => {
  const footerRef = useRef(null);
  const anchorRef = useRef(null);
  const [footerVisible, setFooterVisible] = useState(false);
  const [btnHidden, setBtnHidden] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setFooterVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (footerRef.current) {
      observer.observe(footerRef.current);
    }

    const handleScroll = function () {
      setBtnHidden(window.pageYOffset < 300);
    };

    // リロード時に現在のスクロール位置で初期化
    handleScroll();

    window.addEventListener("scroll", handleScroll);

    return () => {
      if (footerRef.current) {
        observer.unobserve(footerRef.current);
      }
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // リンククリック時に表示する確認モーダル
  const contextValue = useContext(ModalContext);
  if (contextValue === null) {
    throw new Error('Providerが設定されていません。')
  }
  // リンククリック時の処理
  const externalLinkClick = (e, url: string) => {
    e.preventDefault();
    // 確認モーダルを表示
    contextValue.openModal(url);
  };

  return <>
    <footer className={styles.footer}>
      <div className={styles.footerNavigation}>
        <div className="container">
          <div className={styles.footerCompanyInfo}>
            <div className={styles.footerLogo}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 214 26"><path fill="#2f313b" d="M0 0h6.354l9.855 19.06h.073V0h4.967v25.488h-6.33L5.03 6.409h-.083v19.079H0zm28.544 25.488V0h5.597c5.558 0 12.188-.191 12.183 6.892 0 2.999-2.042 5.472-5.335 5.926v.058c1.407.119 2.231 1.487 2.736 2.645l4.156 9.967H42.1l-3.109-7.963c-.747-1.918-1.412-2.631-3.599-2.631h-1.664v10.594zm5.189-21.485v6.869h1.703c2.556 0 5.475-.488 5.475-3.549s-2.876-3.32-5.475-3.32zM53.177 0h5.185v25.488h-5.185zm22.534 0h6.378l9.851 19.022h.073V0h4.962v25.488h-6.33L80.756 6.409h-.068v19.079h-4.977zM118.3 20.428v3.975c-1.828.956-3.87 1.506-6.557 1.506-6.286 0-9.962-3.582-9.962-9.747 0-5.453 2.92-9.939 8.866-9.939 7.052 0 9.065 4.787 9.065 11.345h-13.193c.223 3.032 2.382 4.759 5.457 4.759 2.401 0 4.472-.88 6.324-1.899m-11.781-6.203h8.445c-.146-2.378-1.266-4.425-4.031-4.425s-4.186 1.885-4.414 4.425m19.445-3.994h-3.672V6.658h3.672v-3.75l4.962-1.593v5.338h4.399v3.573h-4.399v8.777c0 1.592.436 3.099 2.323 3.099.897 0 1.746-.182 2.25-.516l.161 3.902c-1.029.259-2.183.421-3.662.421-3.885 0-6.034-2.382-6.034-6.127zm28.092.425c-.924-.409-1.936-.693-3.526-.693-3.221 0-5.442 2.429-5.442 6.012s1.906 6.189 5.558 6.189c1.475 0 3.109-.512 4.006-.885l.228 4.099c-1.518.43-3.075.617-5.209.617-6.572 0-9.87-4.238-9.87-10.025s3.415-9.853 9.672-9.853c2.1 0 3.618.22 5.058.632zm14.051-4.443c5.67 0 9.996 3.764 9.996 9.977 0 5.4-3.662 9.709-9.996 9.709s-9.958-4.309-9.958-9.709c0-6.213 4.332-9.977 9.958-9.977m0 15.884c3.822 0 4.811-3.353 4.811-6.51 0-2.879-1.557-5.576-4.811-5.576s-4.773 2.769-4.773 5.576c0 3.119.99 6.51 4.773 6.51m14.556-15.439h4.486v2.63h.068c1.508-2.305 3.705-3.08 5.495-3.08 2.58 0 4.414.995 5.457 3.334 1.125-2.267 3.526-3.334 5.791-3.334 4.559 0 5.844 3.19 5.844 7.39v11.866h-4.806V14.253c0-1.755 0-4.243-2.76-4.243-3.206 0-3.599 3.884-3.599 6.328v9.126h-4.811V14.253c0-1.755 0-4.243-2.76-4.243-3.196 0-3.594 3.884-3.594 6.328v9.126h-4.811z"/></svg>
            </div>
            <dl className={styles.footerAddressList}>
              <div>
                <dt>大阪本社</dt>
                <dd>〒530-0005　大阪府大阪市北区中之島3-2-4<br />中之島フェスティバルタワー・ウエスト24F<br />TEL：06-7166-1520（代表）</dd>
              </div>
              <div>
                <dt>東京本社</dt>
                <dd>〒105-7114　東京都港区東新橋1-5-2<br />汐留シティセンター14F<br />TEL：03-6274-1200（代表）</dd>
              </div>
            </dl>
          </div>
          <div className={styles.footerLinkList}>
            <div className={styles.footerNavList}>
              <div className={styles.footerGlobalList}>
                <ul className={styles.__feature}>
                  <li><Link to="/feature">NRIネットコムの強み</Link>
                    <ul>
                      <li><Link to="/feature/solution">ソリューション例</Link></li>
                    </ul>
                  </li>
                </ul>
                <ul>
                  <li><Link to="/service">サービス</Link></li>
                  <li><Link to="/work">事例</Link></li>
                  <li><Link to="/event">セミナー／イベント</Link></li>
                </ul>
                <ul className={styles.__company}>
                  <li><Link to="/company">会社情報</Link>
                    <ul>
                      <li><Link to="/company/philosophy"><span>私たちの想い</span></Link></li>
                      <li><Link to="/company/message"><span>社長メッセージ</span></Link></li>
                      <li><Link to="/company/overview"><span>会社概要</span></Link></li>
                      <li><Link to="/company/history"><span>沿革</span></Link></li>
                      <li><Link to="/company/organization"><span>組織図</span></Link></li>
                      <li><Link to="/company/health-management"><span>健康経営への取り組み</span></Link></li>
                      <li><Link to="/company/office"><span>アクセス</span></Link></li>
                    </ul>
                  </li>
                </ul>
              </div>
              <ul className={styles.footerInfoList}>
                <li><Link to="/news">お知らせ</Link></li>
                <li><Link to="/books">出版物</Link></li>
                <li><a href="https://tech.nri-net.com/" target="_blank" rel="noopener noreferrer" onClick={(e) => externalLinkClick(e, "https://tech.nri-net.com/")}>ブログ</a></li>
                <li><a href="/recruit/" target="_blank" rel="noopener noreferrer">採用情報</a></li>
                <li><Link to="/download">資料ダウンロード</Link></li>
                <li><a href="https://dsx-marketing.nri-net.com/contact/form/general/" target="_blank" rel="noopener noreferrer" className="link-hubspot">お問い合わせ</a></li>
              </ul>
            </div>
            <dl className={styles.footerCloudList}>
              <dt>
                <a href="https://cloud.nri-net.com/" target="_blank">
                  <StaticImage
                    loading="lazy"
                    src="../assets/images/common/img_nri-cloudsolution.png"
                    alt="クラウドの活用なら　NRIネットコムのクラウドソリューションサービス"
                  />
                </a>
              </dt>
              <dd>
                <ul className={styles.footerSocialIscons}>
                  <li><a href="https://www.youtube.com/channel/UChnBMhqqaC7lGLFM4pOkNeA" className={`link-image ${styles.__icon01}`} target="_blank"></a></li>
                  <li><a href="https://www.instagram.com/nnc_netcom_pr" className={`link-image ${styles.__icon02}`} target="_blank"></a></li>
                  <li><a href="https://x.com/nri_netcom_pr" className={`link-image ${styles.__icon03}`} target="_blank"></a></li>
                </ul>
              </dd>
            </dl>
            <div className={styles.footerFigure}>
              <StaticImage
                loading="lazy"
                src="../assets/images/common/figure-footer.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.navPagetop}>
        <button
          type="button"
          ref={anchorRef}
          className={`${styles.button} ${footerVisible ? styles.isStack : ''} ${btnHidden ? styles.isHidden : ''}`}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >ページトップへ</button>
      </div>
      <div className={styles.footerStatement}>
        <ul ref={footerRef} className={styles.footerSiteInfo}>
          <li><Link to="/company/office">アクセス</Link></li>
          <li><Link to="/disclaimer">免責事項</Link></li>
          <li><Link to="/site-policy">サイト利用規定</Link></li>
          <li><Link to="/privacy-policy">個人情報保護方針</Link></li>
          <li><Link to="/privacy">個人情報の取り扱いについて</Link></li>
        </ul>
        <p className={styles.logoGroup}>
          <svg className={styles.logoGroup__svg}>
            <use href="/images/top/logo_nrigroup.svg#svg" />
          </svg>
        </p>
        <p className={styles.copyright}>&copy; NRI Netcom, Ltd. All rights reserved.</p>
      </div>
    </footer>
  </>;
};

export default Footer;
